'use strict';

export default [
	{ name: 'Nutritional Analysis', description: ' In-depth nutrition analysis of dietary intake', max_days: 31},
	{ name: 'Weight Log', description: 'Weights with date logged from the daily log section', max_days: null},
	{ name: 'Food Insights', description: 'Top foods contributing to dietary intake of calories, macro and micronutrients', max_days: 31}
]
